import React from "react";
import { useParams, useSearchParams } from 'react-router-dom';
import { TitleParagraphSection } from './PrivacyPolicyPage.js'
import './PrivacyFAQ.css'

export function FAQPage({faqs}) {
    const {appName} = useParams();
    return (
        <>
        <div className="Page">
            <div className="Page-Content">
                <h1> FAQ for {appName}</h1>
                {
                    faqs.map((faq, index) => (
                        <TitleParagraphSection
                        key={index}
                        title={faq.question}
                        text={faq.text}
                        />
                    ))
                }
            </div>
        </div>
        </>
    )
}